import { spacingVars } from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';

export const slideoverActionsContainerClass = style({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: spacingVars.lg,
});
